import { render, staticRenderFns } from "./rfp-form-submission.vue?vue&type=template&id=70ec492e&"
import script from "./rfp-form-submission.vue?vue&type=script&lang=js&"
export * from "./rfp-form-submission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports